const ConsentRecipe = {
    $type$: 'Recipe',
    name: 'Consent',
    rule: [
        {
            itemprop: 'fileReference',
            itemtype: {
                type: 'referenceToObj',
                allowedTypes: new Set(['BlobDescriptor'])
            },
            optional: true
        },
        {
            itemprop: 'status',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'isoStringDate',
            itemtype: { type: 'string' }
        }
    ]
};
const ConsentRecipes = [ConsentRecipe];
export default ConsentRecipes;
//# sourceMappingURL=ConsentRecipes_1_0_0.js.map